/**
 * Avatar-stack icon rendered inline as the FOMO nudge's leading visual.
 *
 * Per the FOMO Nudge doc § "Custom Rovo Nudge UI":
 *   - shows up to 3 collaborator avatars who are Rovo Chat MAU
 *   - When collaborators is empty (Phase 2/3) or avatarUrl is null, AvatarGroup
 *     renders the default generic user avatar automatically (ADS fallback).
 *   - Phase 4: real collaborators supplied via TWG / AGG
 */

import React from 'react';

import AvatarGroup from '@atlaskit/avatar-group';

import type { FomoCollaborator } from '../types';

/** Shown when no real collaborator data is available yet (Phase 2 / Phase 3). */
const PLACEHOLDER_AVATARS = [{ name: '' }, { name: '' }, { name: '' }];

export interface FomoNudgeIconProps {
	collaborators: ReadonlyArray<FomoCollaborator>;
}

export function FomoNudgeIcon({ collaborators }: FomoNudgeIconProps): React.JSX.Element {
	const data =
		collaborators.length > 0
			? collaborators.map((c) => ({
					name: c.displayName ?? '',
					src: c.avatarUrl ?? undefined,
				}))
			: PLACEHOLDER_AVATARS;

	return <AvatarGroup size="small" maxCount={3} data={data} />;
}
